<style>
    .content {
        text-align: center;
    }
</style>

<template>
    <v-jumbotron color="grey lighten-2" centered class="content">
        <v-container fill-height>
        <v-layout align-center>
            <v-flex>
            <h3 class="display-3">{{ this.title }}</h3>
            <v-divider class="my-3"></v-divider>
            <div class="title mb-3">{{ this.message }}</div>
            <v-btn large color="primary" class="mx-0" @click="gotoEfforts()">Go to efforts</v-btn>
            </v-flex>
        </v-layout>
        </v-container>
    </v-jumbotron>
</template>
<script>

import { store } from '../store'

export default {
    name: 'thankyou-page',
    data() {
        return {
            title: 'Thank you!',
            message: 'You have completed all your grades successfully'
        }
    },
    methods: {
        gotoEfforts() {
            var usertype = this.$store.state.usertype;
            var userId = this.$store.state.userdata.id;
            var effortsUrl = '#/' + usertype + '/' + userId + '/' + usertype + '-efforts';
            window.location.href = effortsUrl;
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/Thankyou.vue